import { lazy } from "react";

export const misRoutes = [
  { path: "/Deposits", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/Deposits")) },
  { path: "/Certificates", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/Certificates")) },
  { path: "/nocfeeindustries", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/NOCfeeindustries")) },
  { path: "/SaleOfGPProduces", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/SaleOfGpProduces")) },
  { path: "/RTIdocumentFee", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/RTIdocumentFee")) },
  { path: "/GarbageFee", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/GarbageFee")) },
  { path: "/FinesPenalties", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/FinesPenalties")) },
  { path: "/MisReceiptsofDCB", component: lazy(() => import("../../Components/Masters/MisReceiptsofDCB")) },
  { path: "/RentsLatest", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/RentsLatest")) },
  
];